import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Documentation for v1.0.0 https://github.com/JedWatson/react-select/tree/v1.x
import Select, { Creatable } from 'react-select';
import styles from './LineSelect.scss';
const cx = require('classnames/bind').bind(styles);

class LineSelect extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    arrowRenderer: PropTypes.func,
    creatable: PropTypes.bool,
    floatingLabelText: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.array,
  };

  static defaultProps = {
    arrowRenderer: ({ isOpen }) => (
      <div className={isOpen ? styles.arrowUp : styles.arrowDown} />
    ),
    onChange: () => {},
    floatingLabelText: '',
    creatable: false,
    options: [],
    meta: {},
  };

  state = {};

  render() {
    const {
      arrowRenderer,
      floatingLabelText,
      options,
      onChange,
      creatable,
      meta: { touched, error },
      ...args
    } = this.props;

    return (
      <div
        className={cx('wrap', {
          error: touched && error,
        })}
      >
        <label>{floatingLabelText}</label>
        {creatable ? (
          <Creatable
            arrowRenderer={arrowRenderer}
            options={options}
            onChange={onChange}
            {...args}
          />
        ) : (
          <Select
            arrowRenderer={arrowRenderer}
            options={options}
            onChange={onChange}
            {...args}
            // for hide a wierd block
            autosize={false}
          />
        )}
        {touched && error && <p className={styles.error}>{error}</p>}
      </div>
    );
  }
}

export default LineSelect;



// WEBPACK FOOTER //
// ./app/components/fields/LineSelect/LineSelect.jsx